export const LOCATION = `
name
coordinates {
  latitude
  longitude
}`;
